import {Item} from '../../generated/types';

export function getItemDamage(item: Item) {
	if (!item.dmg1) return null;

	let result = `${item.dmg1} ${ItemDamageTypes[item.dmgType || 'unknown']}`;
	if (item.dmg2) result += ` или ${item.dmg2}, держа оружие в обеих руках`;

	return result;
}

const ItemDamageTypes = {
	acid: 'урона Кислотой',
	bludgeoning: 'Дробящего урона',
	cold: 'урона Холодом',
	fire: 'урона Огнём',
	force: 'урона Силой',
	lightning: 'урона Молнией',
	necrotic: 'Некротического урона',
	piercing: 'Колющего урона',
	poison: 'урона Ядом',
	psychic: 'Психического урона',
	radiant: 'Лучистого урона',
	slashing: 'Режущего урона',
	thunder: 'урона Громом',
	unknown: 'урона',
};
